<div class="ShapeListContainer">
  <mat-list id="list-shape-main-content" class="list-shape-main-content ShapeList">

    <mat-list-item [disabled]="HTML_DISABLED">
      <button (click)="shape99Click()" [disabled]="HTML_DISABLED" style="width: 100%" mat-raised-button>{{'Forme 99' | translate}}</button>
    </mat-list-item>

    <mat-list-item *ngIf="getShowInputDistribution()" [disabled]="HTML_DISABLED">
      <button (click)="inputRepartitionClick()" [disabled]="HTML_DISABLED" style="width: 100%" mat-raised-button>{{'Répartition' | translate}}</button>
    </mat-list-item>

    <mat-list-item *ngIf="HTML_OptionMesh" [disabled]="HTML_DISABLED">
      <button (click)="mOnWMeshCLick.emit()" [disabled]="HTML_DISABLED" style="width: 100%" mat-raised-button>{{'Treillis soudé' | translate}}</button>
    </mat-list-item>

    <ng-container *ngFor="let formes of GetSortedShapes()" >
      <mat-list-item [disabled]="HTML_DISABLED" style="height: 100px;" (click)="HTML_OnShapeClick(formes)">
        <button id="ArmaShapeFavoriteBtn-{{formes.CodeForme}}"
              *ngIf="IsFavorite(formes) != null"
              mat-icon-button
              class="ArmaShape-Favorite {{IsFavorite(formes) ? 'checked' : 'unchecked'}}"
              (click)="ToggleFavorite($event, formes)">
          <mat-icon>star</mat-icon>
      </button>
        {{formes.CodeForme}}
        <arma-shape
          [shape] ="formes"
          width = "225"
          height = "100"
          [Entermeasure] = "false"
          id="example-forme-trace-{{formes.CodeForme}}">
        </arma-shape>
      </mat-list-item>
    </ng-container>
  </mat-list>
  <div class="SearchShapeBtnContainer">
    <button (click)="SearchShapeClick()" [disabled]="HTML_DISABLED" style="width: 100%;" mat-raised-button color="primary">
      <mat-icon>library_add</mat-icon>
      {{ 'Ajouter formes' | translate }}
    </button>
  </div>
</div>
